<template>
    <div>
        <v-select
            v-model="selected"
            :options="selectOptions"
            :label="label"
        ></v-select>
        <input type="hidden" :name="name" :value="selectedKey" />
    </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'vue-select',
    components: {
        'v-select': vSelect
    },
    props: {
        options: {
            required: true,
            type: Array
        },
        label: {
            required: true,
            type: String
        },
        name: {
            required: true,
            type: String
        },
        selectedOption: {
            required: false,
            type: Number,
            default: null
        },
        field: {
            required: false,
            type: String,
            default: "id"
        },
        nullable: {
            required: false,
            type: Boolean,
            default: true
        },
        none: {
            required: false,
            type: String,
            default: 'none'
        }
    },
    data () {
        return {
            selected: null,
            selectOptions: []
        }
    },
    computed: {
        selectedKey () {
            if (this.selected) {
                return this.selected[this.field];
            }
            return null;
        }
    },
    mounted () {
        this.selectOptions = _.clone(this.options);

        if (this.nullable) {
            let empty = {};
            empty[this.field] = null;
            empty[this.label] = this.none;
            this.selectOptions.unshift(0);
            this.selectOptions[0] = empty;
        }

        let search = {};
        let option = null;
        if (this.selectedOption) {
            option = this.selectedOption;
        }
        search[this.field] = option;
        this.selected = _.find(this.selectOptions, search);
    }
}
</script>

<style scoped>

</style>
